"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePayCodePolicy = void 0;
const luxon_1 = require("luxon");
const react_query_1 = require("react-query");
const fetchClient_1 = require("../../client/fetchClient");
const paths_1 = require("../../paths");
const DateManagement_1 = require("../../utils/DateManagement");
const taaConfigs_1 = require("../../contexts/taaConfigs");
function usePayCodePolicy({ employeeId, payPeriodBreakdownInfo, language, shouldFetch, usageLocation }) {
    const currentPayPeriodStartDT = luxon_1.DateTime.fromISO(payPeriodBreakdownInfo === null || payPeriodBreakdownInfo === void 0 ? void 0 : payPeriodBreakdownInfo.current.start_time);
    const { host, clientName, currentStage } = (0, taaConfigs_1.useTaaConfigsContext)();
    const ApiPath = (0, paths_1.GET_PAY_CODE_POLICY_API)(employeeId, (0, DateManagement_1.trimISOStringMilliseconds)(currentPayPeriodStartDT), (0, DateManagement_1.trimISOStringMilliseconds)(currentPayPeriodStartDT), language);
    const { isLoading: isPayCodePolicyLoading, data: getPayCodePolicyResponse } = (0, react_query_1.useQuery)(['payCodePolicy', ApiPath], () => (0, fetchClient_1.getData)({
        path: ApiPath,
        host,
        metaData: {
            apiName: 'getPayCodePolicy',
            clientName
        },
        usageLocation
    }, currentStage), {
        enabled: !!employeeId && !!payPeriodBreakdownInfo && shouldFetch,
        staleTime: 60 * 1000,
        retry: false
    });
    const payCodePolicyInfo = getPayCodePolicyInfo(getPayCodePolicyResponse);
    return {
        isPayCodePolicyLoading,
        payCodePolicyInfo,
        errorMessage: getPayCodePolicyResponse === null || getPayCodePolicyResponse === void 0 ? void 0 : getPayCodePolicyResponse.errorMessage
    };
}
exports.usePayCodePolicy = usePayCodePolicy;
const getPayCodePolicyInfo = (usePayCodePolicyResponse) => {
    if (!(usePayCodePolicyResponse === null || usePayCodePolicyResponse === void 0 ? void 0 : usePayCodePolicyResponse.isEmployeeEligible))
        return {
            lastRevisedAtDate: '',
            payCodePolicies: []
        };
    return {
        lastRevisedAtDate: usePayCodePolicyResponse.lastRevisedAt,
        payCodePolicies: usePayCodePolicyResponse.payCodePolicyEntries
    };
};
